<template>
    <div ref="topbar" class="topbar">
        <div ref="title">
            <span class="blue-text">Echwood</span>
            <span ref="developerText" class="blue-text">Developer</span>
        </div>
        <div class="slack-link">
            <a class="slack-button blue" target="_blank" href="https://echwoodhub.slack.com">
                Join Us on <img class="sla-mg" style="width:1%,height:1%" src="../assets/sl.png">Slack
            </a>
            <a class="slack-button-mobile" target="_blank" href="https://echwoodhub.slack.com">
                <img class="sla-mg" style="width:1%,height:1%" src="../assets/sl.png">
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'topbar',

    mounted() {
        window.onscroll = () => {
            if (document.body.scrollTop > 80 || document.documentElement.scrollTop > 80) {
                this.$refs.topbar.classList.add('sticky')
            } else {
                this.$refs.topbar.classList.remove('sticky')
            }
        }
    }
}
</script>

<style scoped>
.topbar {
    position: fixed;
    left: 0;
    top: 0;
    right: 0;
    z-index: 1000;
    /* border-bottom: 2px solid #ccc; */
    padding: 0 1em;
    /* background-color: #FEFEFE; */
    height: 10vh;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    transition: all .35s ease-in-out 0s;
    /* box-shadow: 0 1px 1px rgba(0,0,0,.1); */
}

.topbar .slack-link {
    display: none;
}

div > span {
  font-weight: 600;
  font-size: 28px;
  text-shadow: 0 5px .7em 3px #333;
    transition: all .35s ease-in-out 0s;
}

div > span:last-child {
  font-weight: 300;
  color: #FAFAFA;
}

div > span:first-child {
  /* color: #333; */
}

.slack-button {
  padding: .3em 2em;
  border-radius: 3.5px;
  font-size: 16px;
  display: block;
  border: 1px solid #FEFEFE;
  color: #FEFEFE;
  transition: all 0.25s ease-in-out 0s;
}

.slack-button:hover {
  background-color: #F8F8F8;
  border: 2px solid #2199e8;
  color: #2199e8;
}

.slack-button-mobile {
    border-radius: 100%;
    background-color: #FAFAFA;
    display: none;
    align-items: center;
    justify-content: center;
    padding: .5em;
}

img {
    width: 2em;
}

.sticky {
    background-color: #FFF;
    justify-content: space-between;
    box-shadow: 0 0 4px rgba(0,0,0,.14), 0 4px 8px rgba(0,0,0,.28);
}

.sticky div span:last-child {
    color: #555;
}

.sticky div span {
  font-size: 23px;
}

.sticky .slack-link {
    display: block;
}

@media screen and (min-width: 320px) and (max-width: 490px) {
    .topbar {
        justify-content: center;
    }
    .topbar.sticky {
        justify-content: space-between;        
    }
    .slack-button {
        display: none;
    }
    .slack-button-mobile {
        display: flex;
    }
}

</style>

